
import { mixins } from 'vue-class-component'
import { Component, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Case } from '@/modules/Newcase/interfaces/case'
import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors, showNotification } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { getMyCases, updateMyTopCases, editCaseById, getNewCasesFromProducer } from '@/modules/Newcase/gql/case.gql'
import { caseType, caseTypeClass, casePriorityClass, caseTypeKeys, caseTypeValues, casePriorityKeys, casePriorityValues, caseLevelValues, caseLevelKeys, casePhaseKeys, casePhaseValues } from '@/modules/Newcase/helpers/case'
import ListPage from '@/mixins/list-page'
import SearchCarrierProduct from '@/mixins/search-queries/search-carrier-product'
import CaseDialog from '@/modules/Newcase/scripts/case-dialog'
import CaseDashboardCard2 from '../components/CaseDashboardCard2.0.vue'
import CaseDashboardCard from '../components/CaseDashboardCard.vue'
import AppFilterButton from '@/components/AppFilterButton.vue'
import AppSimpleTextField from '@/components/AppSimpleTextField.vue'
import AppSimpleSelector from '@/components/AppSimpleSelector.vue'
import AppCheckbox from '@/components/AppCheckbox.vue'
import RecordTypesHandler from '@/mixins/record-types'
import { SnackType } from '@/interfaces/snack'
import AppPagination from '@/components/AppPagination.vue'
import CaseFormPolicy from '../components/forms/CaseFormPolicy.vue'
import CaseTypeSelector from '@/modules/Case/components/CaseTypeSelector.vue'
import { newCase } from '../gql/case.gql'
import { ICasePolicyInput } from '../interfaces/case-form'

@Component({
  components: {
    AppBreadcrumbs,
    CaseDashboardCard2,
    AppFilterButton,
    AppSimpleTextField,
    AppCheckbox,
    AppSimpleSelector,
    CaseDashboardCard,
    AppPagination,
    CaseTypeSelector,
    CaseFormPolicy
  }
})
export default class CaseDashboard extends mixins(CaseDialog, ListPage, SearchCarrierProduct, RecordTypesHandler) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Insurance Cases'
    },
    {
      text: 'Case2.0'
    }
  ]

  currentPage = 1

  pageLength = 0

  pageSize = 1

  searchVal = ''
  searchAllVal = ''

  priorityOptions = [
    'Low',
    'Medium',
    'High'
  ]

  caseTypeClass = caseTypeClass
  casePriorityClass = casePriorityClass

  topCaseList = []
  currentTopList = []
  importantAndUrgentCaseList = []
  importantCaseList = []
  urgentCaseList = []
  othersCaseList = []
  fromProducer = []

  caseType = caseType

  sortBy = 'ID'
  sortDesc = true

  isSimple = false

  myHotCases: Case[] = []
  allCases: Case[] = []

  tableLoading = false
  myCaseLoading = false

  salesCasesCurrentPage = 1
  serviceCasesCurrentPage = 1

  salesCasesTotalCount = 0
  serviceCasesTotalCount = 0

  perPageNum = 8

  order = {
    sales: {
      orderBy: 'UPDATED_AT',
      asc: false
    },
    service: {
      orderBy: 'UPDATED_AT',
      asc: false
    }
  }

  isTop = true

  filter: {
    [key: string]: any;
  } = {}

  isShowClosed = false

  isCreateEndorsement = false

  policyInput: ICasePolicyInput = {
    policy: {}
  }

  topListHeight = '0px'

  topListWidth = 0

  bottomLeftListWidth = '450px'

  caseTypeOptions = caseTypeValues

  casePriorityOptions = casePriorityValues

  caseLevelOptions = caseLevelValues

  casePhaseOptions = casePhaseValues

  topRequestDebounce = false

  importantRequestDebounce = false

  urgentRequestDebounce = false

  caseGroupTypes = {
    t: 'top',
    iu: 'importantAndUrgent',
    i: 'important',
    u: 'urgent',
    o: 'others'
  }

  get bottomListHeight () {
    return { height: `calc(100vh - 220px - ${this.topListHeight})` }
  }

  get productTypeOptions () {
    if (this.$R.isEmpty(this.recordTypesOptions)) {
      return []
    }
    return this.recordTypesOptions['POLICY'].map(template => template.title)
  }

  get topCaseIds () {
    return this.topCaseList.map((item: Case) => +item.id)
  }

  @State(state => state.theCase.sales) salesCases!: Case[]
  @State(state => state.theCase.service) serviceCases!: Case[]

  @Watch('isSimple')
  onIsSimpleChanged (val: boolean) {
    this.perPageNum = val ? 12 : 8
  }

  @Watch('isShowClosed')
  onIsShowClosedChanged (val: boolean) {
    this.getCasesQuery()
  }

  async mounted () {
    await this.getRecordTypes('POLICY')
    await this.getCasesQuery()
    this.geTopListHeight()
    this.setTopListPage()
    this.setBottomLeftListWidth()
    setTimeout(() => {
      this.getCasesQuery()
    }, 60 * 1000)
    window.onresize = () => {
      this.currentPage = 1
      this.geTopListHeight()
      this.setTopListPage()
      this.setBottomLeftListWidth()
    }
  }

  caseTypeChangeHandler (index: number) {
    this.isTop = index === 0
    this.getMyCasesList()
  }

  handleCreateEndorsement () {
    this.isCreateEndorsement = true
  }

  async confirmCreateEndorsement () {
    const { policy } = this.policyInput
    try {
      const res = await this.$apollo.mutate({
        mutation: newCase,
        variables: {
          caseInput: {
            inquiryName: policy.name,
            type: 'ENDORSEMENT',
            recordTypeId: policy.recordType && policy.recordType.id ? +policy.recordType.id : -1,
            targetPolicyId: policy.id
          }
        }
      })
      this.isCreateEndorsement = false
      showNotification({
        msg: 'Create successfully',
        type: SnackType.Success
      })
      this.getCasesQuery()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  routeToCreate () {
    this.$router.push({
      name: 'NewcaseCreate'
    })
  }

  async getCasesQuery () {
    await Promise.all([
      this.getMyCasesList(),
      this.getCasesFromProducer()
    ])
  }

  async getMyCasesList () {
    const { priority, clientLevel, accountName, caseType, phase, recordType } = this.filter
    const { recordTypes } = this
    const filter: {
      [key: string]: unknown;
    } = {}
    if (casePriorityKeys[priority]) {
      filter.clientPriority = +casePriorityKeys[priority]
    }
    if (caseLevelKeys[clientLevel]) {
      filter.clientLevel = +caseLevelKeys[clientLevel]
    }
    if (accountName) {
      filter.accountName = accountName
    }
    if (caseTypeKeys[caseType]) {
      filter.type = caseTypeKeys[caseType]
    }
    if (this.filter.phase !== null && !isNaN(this.filter.phase) && this.filter.phase !== -1) {
      filter.phase = casePhaseKeys[this.filter.phase]
    }
    if (recordTypes[recordType]) {
      filter.recordTypeId = +recordTypes[recordType].id
    }

    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getMyCases,
        variables: {
          filter: filter,
          isTop: this.isTop,
          isOpen: !this.isShowClosed
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const res = result.data.getMyCases
      this.topCaseList = res.top
      this.importantAndUrgentCaseList = res.importantAndUrgent
      this.importantCaseList = res.important
      this.urgentCaseList = res.urgent
      this.othersCaseList = res.others
      this.currentPage = 1
      this.setTopListPage()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getCasesFromProducer () {
    const { priority, clientLevel, accountName, caseType, phase, recordType } = this.filter
    const { recordTypes } = this
    const filter: {
      [key: string]: unknown;
    } = {}
    if (casePriorityKeys[priority]) {
      filter.clientPriority = +casePriorityKeys[priority]
    }
    if (caseLevelKeys[clientLevel]) {
      filter.clientLevel = +caseLevelKeys[clientLevel]
    }
    if (accountName) {
      filter.accountName = accountName
    }
    if (caseTypeKeys[caseType]) {
      filter.type = caseTypeKeys[caseType]
    }
    if (this.filter.phase !== null && !isNaN(this.filter.phase) && this.filter.phase !== -1) {
      filter.phase = casePhaseKeys[this.filter.phase]
    }
    if (recordTypes[recordType]) {
      filter.recordTypeId = +recordTypes[recordType].id
    }
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getNewCasesFromProducer,
        variables: {
          filter: filter,
          order: {
            orderBy: 'CREATED_AT',
            asc: false
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const res = result.data.getNewCasesFromProducer
      this.fromProducer = res
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async unTop ({ index, item }: { index: number, item: Case }) {
    const { topCaseList, importantAndUrgentCaseList, importantCaseList, urgentCaseList, othersCaseList, $R } = this

    if (this.topRequestDebounce) {
      return
    }

    this.topRequestDebounce = true

    this.topCaseList = $R.remove(index, 1, topCaseList)
    const { important, urgent } = item

    switch (true) {
      case important && urgent:
        this.importantAndUrgentCaseList = $R.prepend(item, importantAndUrgentCaseList)
        break
      case important:
        this.importantCaseList = $R.prepend(item, importantCaseList)
        break
      case urgent:
        this.urgentCaseList = $R.prepend(item, urgentCaseList)
        break
      default:
        this.othersCaseList = $R.prepend(item, othersCaseList)
        break
    }

    this.topRequestDebounce = false

    this.$nextTick(() => {
      this.geTopListHeight()
      this.setTopListPage()
      this.setBottomLeftListWidth()
    })

    this.sendChangeTopRequest()
  }

  async onTop ({ index, item }: { index: number, item: Case }) {
    const { topCaseList, importantAndUrgentCaseList, importantCaseList, urgentCaseList, othersCaseList, $R } = this

    if (this.topRequestDebounce) {
      return
    }
    this.topRequestDebounce = true

    const { important, urgent } = item

    switch (true) {
      case important && urgent:
        this.importantAndUrgentCaseList = $R.remove(index, 1, importantAndUrgentCaseList)
        break
      case important:
        this.importantCaseList = $R.remove(index, 1, importantCaseList)
        break
      case urgent:
        this.urgentCaseList = $R.remove(index, 1, urgentCaseList)
        break
      default:
        this.othersCaseList = $R.remove(index, 1, othersCaseList)
        break
    }

    this.topCaseList = $R.prepend(item, topCaseList)

    this.$nextTick(() => {
      this.geTopListHeight()
      this.setTopListPage()
      this.setBottomLeftListWidth()
    })

    this.topRequestDebounce = false

    this.sendChangeTopRequest()
  }

  async onImportantChange ({ item, index, caseImpUrgType }: { item: Case, index: number, caseImpUrgType: string }) {
    const { importantAndUrgentCaseList, importantCaseList, urgentCaseList, othersCaseList, caseGroupTypes, $R } = this

    if (this.importantRequestDebounce) {
      return
    }

    this.importantRequestDebounce = true

    item.important = !item.important

    switch (caseImpUrgType) {
      case caseGroupTypes.o:
        this.othersCaseList = $R.remove(index, 1, othersCaseList)
        this.importantCaseList = $R.prepend(item, importantCaseList)
        break
      case caseGroupTypes.iu:
        this.importantAndUrgentCaseList = $R.remove(index, 1, importantAndUrgentCaseList)
        this.urgentCaseList = $R.prepend(item, urgentCaseList)
        break
      case caseGroupTypes.i:
        this.importantCaseList = $R.remove(index, 1, importantCaseList)
        this.othersCaseList = $R.prepend(item, othersCaseList)
        break
      case caseGroupTypes.u:
        this.urgentCaseList = $R.remove(index, 1, urgentCaseList)
        this.importantAndUrgentCaseList = $R.prepend(item, importantAndUrgentCaseList)
        break
      default:
        break
    }

    this.$nextTick(() => {
      this.setBottomLeftListWidth()
    })

    this.importantRequestDebounce = false

    this.sendImportantChangeRequest(item, item.important)
  }

  async onUrgentChange ({ item, index, caseImpUrgType }: { item: Case, index: number, caseImpUrgType: string }) {
    const { importantAndUrgentCaseList, importantCaseList, urgentCaseList, othersCaseList, caseGroupTypes, $R } = this

    if (this.urgentRequestDebounce) {
      return
    }

    this.urgentRequestDebounce = true

    item.urgent = !item.urgent

    switch (caseImpUrgType) {
      case caseGroupTypes.o:
        this.othersCaseList = $R.remove(index, 1, othersCaseList)
        this.urgentCaseList = $R.prepend(item, urgentCaseList)
        break
      case caseGroupTypes.iu:
        this.importantAndUrgentCaseList = $R.remove(index, 1, importantAndUrgentCaseList)
        this.importantCaseList = $R.prepend(item, importantCaseList)
        break
      case caseGroupTypes.i:
        this.importantCaseList = $R.remove(index, 1, importantCaseList)
        this.importantAndUrgentCaseList = $R.prepend(item, importantAndUrgentCaseList)
        break
      case caseGroupTypes.u:
        this.urgentCaseList = $R.remove(index, 1, urgentCaseList)
        this.othersCaseList = $R.prepend(item, othersCaseList)
        break
      default:
        break
    }

    this.$nextTick(() => {
      this.setBottomLeftListWidth()
    })

    this.urgentRequestDebounce = false

    this.sendUrgentChangeRequest(item, item.urgent)
  }

  geTopListHeight () {
    const container = document.querySelector('.c-case-dashboard__container')
    const el = document.querySelector('#topList')
    this.topListHeight = el ? el.clientHeight + 'px' : '0px'
    this.topListWidth = el ? el.clientWidth : 0
    this.pageSize = Math.floor(this.topListWidth / 222) || (container ? container.clientWidth : 0)
  }

  changePagination (currentPage: number) {
    this.currentPage = currentPage
    this.setTopListPage()
  }

  setTopListPage () {
    const { currentPage, pageSize, topCaseList } = this
    this.pageLength = Math.ceil(topCaseList.length / pageSize)
    const fromIndex = (currentPage - 1) * pageSize
    const endIndex = (currentPage - 1) * pageSize + pageSize
    this.currentTopList = topCaseList.slice(fromIndex, endIndex)
    this.$nextTick(() => {
      this.geTopListHeight()
    })
  }

  setBottomLeftListWidth () {
    const leftWidth = document.body.clientWidth - 1082
    if (leftWidth <= 450) {
      this.bottomLeftListWidth = '450px'
      return
    }
    const cardNum = Math.floor((document.body.clientWidth - 1082) / 222)
    const importantAndUrgentCaseListLength = this.importantAndUrgentCaseList.length
    if (importantAndUrgentCaseListLength < cardNum) {
      this.bottomLeftListWidth = importantAndUrgentCaseListLength ? importantAndUrgentCaseListLength * 222 + 6 + 'px' : '222px'
    } else {
      this.bottomLeftListWidth = cardNum * 222 + 6 + 'px'
    }
  }

  async sendChangeTopRequest () {
    try {
      const result = await this.$apollo.mutate({
        mutation: updateMyTopCases,
        variables: {
          caseIds: this.topCaseIds || []
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      showNotification({
        msg: 'Update successfully',
        type: SnackType.Success
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async sendImportantChangeRequest (wfCase: Case, important: boolean) {
    try {
      const res = await this.$apollo.mutate({
        mutation: editCaseById,
        variables: {
          caseId: +wfCase.id,
          caseInput: {
            inquiryName: wfCase.inquiryName,
            important
          }
        }
      })
      showNotification({
        msg: 'Update successfully',
        type: SnackType.Success
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async sendUrgentChangeRequest (wfCase: Case, urgent: boolean) {
    try {
      const res = await this.$apollo.mutate({
        mutation: editCaseById,
        variables: {
          caseId: +wfCase.id,
          caseInput: {
            inquiryName: wfCase.inquiryName,
            urgent
          }
        }
      })
      showNotification({
        msg: 'Update successfully',
        type: SnackType.Success
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
